// extracted by mini-css-extract-plugin
export default {"modalBody":"ViewDocumentModal_modalBody__5XLhS","imageWrap":"ViewDocumentModal_imageWrap__3+XP6"};